"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectionMode = void 0;
var SelectionMode;
(function (SelectionMode) {
    SelectionMode[SelectionMode["Include"] = 1] = "Include";
    SelectionMode[SelectionMode["Exclude"] = 2] = "Exclude";
})(SelectionMode = exports.SelectionMode || (exports.SelectionMode = {}));
//# sourceMappingURL=SelectionMode.js.map